import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAllOutreaches,
  fetchAllOutreachesAll,
  fetchAllOutreachesList,
  fetchAllAddableOutreachesList,
  fetchAllOutreachesUserSender,
} from './actions';

const initialState = {
  isLoading: true,
  data: [],

  isOutreachListLoading: true,
  outreachList: [],

  isOutreachAddableListLoading: true,
  outreachAddableList: [],

  filters: {
    changed: false,
    status: null,
    user: null,
  },

  search: {
    term: null,
  },

  sort: {
    element: 'created_at',
    order: 'DESC',
  },
};

const { reducer, actions } = createSlice({
  name: 'outreaches',
  initialState,

  reducers: {
    applyFilter: (state, { payload: { type, value } }) => {
      state.search.term = '';
      state.filters[type] = value;
      if (type !== 'user') {
        state.filters.changed = true;
      }
    },

    resetFilter: (state) => {
      const user = state.filters.user;
      state.filters = { ...initialState.filters, user };
      state.filters.changed = false;
    },

    applySort: (state, { payload: { element, order } }) => {
      state.search.term = '';
      state.sort.element = element;
      state.sort.order = order;
    },

    updateOutreach: (state, { payload }) => {
      const { id, to } = payload;
      const updatedOutreach = state?.data?.map((outreach) => {
        if (outreach.id === id) {
          return { ...outreach, status: to };
        }
        return outreach;
      });
      state.data = updatedOutreach;
    },

    applySearchTerm: (state, { payload }) => {
      state.search.term = payload?.searchTerm;
    },
  },

  extraReducers: {
    [fetchAllOutreaches.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchAllOutreaches.fulfilled]: (state, { payload }) => {
      state.data = payload?.data || [];
      state.isLoading = false;
    },

    [fetchAllOutreachesAll.pending]: (state) => {
      state.isOutreachListAllLoading = true;
    },
    [fetchAllOutreachesAll.fulfilled]: (state, { payload }) => {
      state.outreachListAll = payload?.data || [];
      state.isOutreachListAllLoading = false;
    },

    [fetchAllOutreachesList.pending]: (state) => {
      state.isOutreachListLoading = true;
    },
    [fetchAllOutreachesList.fulfilled]: (state, { payload }) => {
      state.outreachList = payload?.data || [];
      state.isOutreachListLoading = false;
    },

    [fetchAllAddableOutreachesList.pending]: (state) => {
      state.isOutreachAddableListLoading = true;
    },
    [fetchAllAddableOutreachesList.fulfilled]: (state, { payload }) => {
      state.outreachAddableList = payload?.data || [];
      state.isOutreachAddableListLoading = false;
    },

    [fetchAllOutreachesUserSender.pending]: (state) => {
      state.isOutreachUserSenderLoading = true;
    },
    [fetchAllOutreachesUserSender.fulfilled]: (state, { payload }) => {
      state.outreachUserSender = payload?.data || [];
      state.isOutreachUserSenderLoading = false;
    },
  },
});

export const {
  updateOutreach,
  applyFilter,
  resetFilter,
  applySort,
  applySearchTerm,
} = actions;
export default reducer;
